module.exports = __webpack_public_path__ + "static/media/sell_rating_2.3a9408dd.jpg";